import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Carousel } from 'components/carousel/carousel';
import { usePlatform } from 'core/hooks/platform';
import { Paginator } from 'core/models/paging';
import CarouselItem from 'welcome-screen/carouselItem/carousel-item';
import styles from './welcome-popup.module.scss';

const WelcomePopup = observer(({ popupStore }: any) => {
  const { t } = useTranslation();
  const { platformKey } = usePlatform();

  return (
    <div className={styles.popupContainer}>
      <Carousel
        columnCount={1}
        items={
          new Paginator(
            [
              <CarouselItem
                title={t('welcomePopup.screen1.header')}
                text={t('welcomePopup.screen1.text')}
                image={`welcome-popup/${platformKey}-subscriptions.webp`}
                magnifiedImg="welcome-popup/subscriptions-mgnf.webp"
                ltr={true}
              ></CarouselItem>,
              <CarouselItem
                title={t('welcomePopup.screen2.header')}
                text={t('welcomePopup.screen2.text')}
                image={`welcome-popup/${platformKey}-account.webp`}
                magnifiedImg="welcome-popup/payment-mgnf.webp"
                ltr={true}
              ></CarouselItem>,
              <CarouselItem
                title={t('welcomePopup.screen3.header')}
                text={t('welcomePopup.screen3.text')}
                image={`welcome-popup/${platformKey}-subscriptions.webp`}
                magnifiedImg2="welcome-popup/add-new-mngf.webp"
                magnifiedImg="welcome-popup/addon-mgnf.webp"
                ltr={false}
              ></CarouselItem>,
            ],
            1
          )
        }
      />
      ;
    </div>
  );
});

export default WelcomePopup;